<template>
  <div class="outside-manners">
    <outside-manners-card />
  </div>
</template>

<script>
import OutsideMannersCard from '../cards/OutsideMannersCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'outside-manners',
  components: {
    OutsideMannersCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/services/group-class/outside-manners',
      ogTitle: 'Outside Manners - Rewarding Dog Training',
      ogDescription: 'In this 4 week class, you will take your training to the next level by practicing your recall, leash walking, and leave it in real world situations.',
    })
  },
}
</script>

<style lang="scss">
.outside-manners {
  width: 100%;
}
</style>
